import React from 'react';

import { Box } from '@/components/lib/components';

import { RemovePicksButton } from '../RemovePicksButton';
import { SinglesList } from '../SinglesList';
import { SoccerSettlementBanner } from '../SoccerSettlementBanner';

const ListFooter = () => (
    <Box alignItems="center" mt="s8">
        <RemovePicksButton />
    </Box>
);

export const SinglesTabScreen = () => (
    <SinglesList ListHeaderComponent={SoccerSettlementBanner} ListFooterComponent={ListFooter} />
);
